import { SWRResponse } from "swr";
import useQuery, {
  UseQueryOptions
} from "rivals/shared/hooks/useQuery/useQuery";
import { AthletePageParams } from "rivals/shared/interfaces/Athlete";
import { buildPlayerUrlQueryParams } from "rivals/shared/utils/routes";
import { Response } from "./types";

export default function useGetProspect(
  requestParams: AthletePageParams,
  options?: UseQueryOptions
): SWRResponse<Response> {
  const url = buildPlayerUrlQueryParams(
    `/api/v2/prospects/prospect`,
    requestParams
  );
  return useQuery<Response>(url, options);
}
